/* ============================================================
   YOUNGER — 檢測項目目錄（六大系統版 · 68 項）
   資料來源：bd-wt-data-sys.js（window.BD_WT_DATA）
   衍生自 bd-wt.js（22 大分類版），差異：
   - 分類改為「六大系統」（營養／代謝／心血管／排毒／內分泌／免疫），系統 id 借用既有 ICO key
   - 抽屜的「相關健康狀況」改為散文顯示（原版是標籤化的「可能相關狀態」）
   - desc / cond 皆支援多段（\n\n 分段）與「- 」列點
   - 無加購套組（A），只呈現 68 項核心
   全部 DOM scoped 在 .bdwt 下，與 bd-wt.js 不同頁載入、不衝突。
   rev: 2026-08-14c（膠囊標籤去括號）
   ============================================================ */
(function () {
  'use strict';

  const ICO = {
    heart:'<path d="M12 20s-7-4.3-7-9.5C5 8 6.8 6.5 9 6.5c1.6 0 2.6.8 3 1.4.4-.6 1.4-1.4 3-1.4 2.2 0 4 1.5 4 4C19 15.7 12 20 12 20z"></path><path d="M6 12.5h2.3l1.2-2.4 1.8 4 1.2-2.6H17"></path>',
    thyroid:'<path d="M11.4 12 5 8v8l6.4-4M12.6 12 19 8v8l-6.4-4M11.4 12h1.2"></path>',
    metabolic:'<path d="M17.5 9.5A7 7 0 0 0 6 7"></path><path d="M6 3.8V7h3.2"></path><path d="M6.5 14.5A7 7 0 0 0 18 17"></path><path d="M18 20.2V17h-3.2"></path>',
    toxins:'<path d="M9.5 4h5M11 4v5L6.5 17.5A2 2 0 0 0 8.3 20.5h7.4a2 2 0 0 0 1.8-3L13 9V4"></path><path d="M8 15h8"></path><circle cx="11" cy="17.2" r=".55"></circle><circle cx="13.4" cy="18" r=".55"></circle>',
    nutrients:'<path d="M7.5 13 13 7.5a3 3 0 0 1 4.2 4.2L11.7 17.2A3 3 0 0 1 7.5 13Z"></path><path d="M10.2 10.2 13.9 13.9"></path>',
    immune:'<path d="M12 4l7 2v6c0 4-3 6.7-7 8-4-1.3-7-4-7-8V6z"></path><path d="M9 12l2 2 4-4.5"></path>',
    // 加購面板（bd-wt-items-sys 的 add_panels）共用這顆：閃電＝能量代謝
    addon:'<path d="M13 3 5.5 13.2h5L11 21l7.5-10.2h-5z"></path>'
  };

  const SVG_CHECK = '<svg viewBox="0 0 24 24"><path d="M4 12l5 5L20 6"/></svg>';
  const SVG_CHEV  = '<svg class="rc" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg>';

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => (
    { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]
  ));

  // 把多段文字（\n\n 分段，行首「- 」視為列點）渲染成 <p> / <ul>
  function richHTML(text) {
    const blocks = String(text || '').trim().split(/\n{2,}/).map(b => b.trim()).filter(Boolean);
    return blocks.map(b => {
      const lines = b.split(/\n/).map(l => l.trim()).filter(Boolean);
      const isList = lines.length && lines.every(l => /^[-•]\s+/.test(l));
      if (isList) {
        return '<ul class="wt-ul">' + lines.map(l => `<li>${esc(l.replace(/^[-•]\s+/, ''))}</li>`).join('') + '</ul>';
      }
      return `<p>${esc(b).replace(/\n/g, '<br>')}</p>`;
    }).join('');
  }

  // 語系：<html lang> 由 theme.liquid 依 request.locale.iso_code 輸出
  const IS_EN = /^en/i.test(document.documentElement.getAttribute('lang') || '');
  // 名稱走資料自帶的 en 欄位（M 與 CATS 皆 100% 有 en），英文不需另外翻譯
  const nm = o => (IS_EN && o && o.en) ? o.en : (o ? o.zh : '');
  // 膠囊標籤：拿掉括號內的補充（加購面板的群組名很長，全寫會撐爆左欄）。
  // 只影響膠囊，區塊標題與抽屜仍是完整名稱。
  const chipLabel = o => nm(o).replace(/\s*[（(][^）)]*[）)]\s*/g, ' ').replace(/\s+/g, ' ').trim();
  const UI = IS_EN
    ? { all:'All', unit:n => `${n} items`, cond_h:'Related health conditions',
        st_core:'Core data', core_test:'Core panel',
        st_addon:'Add-on data', addon_test:'Add-on panel',
        core_fallback:c => `A core biomarker in the ${c} system.` }
    : { all:'全部', unit:n => `${n} 項`, cond_h:'相關健康狀況',
        st_core:'核心數據', core_test:'核心檢測',
        st_addon:'加購數據', addon_test:'加購面板',
        core_fallback:c => `${c}系統中的核心檢測項目。` };

  function init(root) {
    if (!root || root.dataset.bdwtReady === '1') return;
    if (!window.BD_WT_DATA) return;
    root.dataset.bdwtReady = '1';

    // 68 項核心之外，若 section 有餵加購面板（window.BD_WT_EXTRA）就併進同一份資料，
    // 讓膠囊／搜尋／抽屜一次涵蓋。沒有 EXTRA 時行為與原本完全相同。
    const X = window.BD_WT_EXTRA;
    const M = X ? Object.assign({}, window.BD_WT_DATA.M, X.M) : window.BD_WT_DATA.M;
    const CATS = X ? window.BD_WT_DATA.CATS.concat(X.CATS) : window.BD_WT_DATA.CATS;
    const $ = sel => root.querySelector(sel);

    /* ---------- chips（系統膠囊） ---------- */
    const chipsEl = $('[data-wt-chips]');
    chipsEl.innerHTML =
      `<button class="wt-chip is-all active" data-cat="">${esc(UI.all)}</button>` +
      CATS.map(c => `<button class="wt-chip" data-cat="${esc(c.id)}" title="${esc(nm(c))}">${esc(chipLabel(c))}</button>`).join('');

    /* ---------- sections（每系統一段） ---------- */
    const mainEl = $('[data-wt-main]');

    function coreRow(cat, i, it) {
      if (!it) return '';
      return `<button type="button" class="wt-row" data-cat="${esc(cat)}" data-kind="core" data-i="${i}" data-name="${esc(it.zh + ' ' + (it.en || ''))}">
        <span class="rk">${SVG_CHECK}</span>
        <span class="rn">${esc(nm(it))}</span>
        ${SVG_CHEV}
      </button>`;
    }

    mainEl.innerHTML = CATS.map(c => {
      const core = c.core || [];
      const coreRows = core.map((k, i) => coreRow(c.id, i, M[k])).filter(Boolean).join('');
      const cnt = core.length ? `<span class="wt-sec-cnt">${esc(UI.unit(core.length))}</span>` : '';
      return `<section class="wt-sec" data-cat="${esc(c.id)}">
        <div class="wt-sec-head">
          <svg class="wt-sec-ico" viewBox="0 0 24 24">${ICO[c.id] || (c.addon ? ICO.addon : '')}</svg>
          <h3>${esc(nm(c))}</h3>${cnt}
        </div>
        <p class="wt-intro">${esc((IS_EN && c.intro_en) ? c.intro_en : c.intro)}</p>
        <div class="wt-rows">${coreRows}</div>
      </section>`;
    }).join('');

    /* 分類說明收合模式：點標題列展開／收起 */
    mainEl.addEventListener('click', e => {
      const head = e.target.closest('.wt-sec-head');
      if (!head) return;
      const r = mainEl.closest('.bdwt');
      if (!r || !r.classList.contains('intro-collapse')) return;
      head.closest('.wt-sec').classList.toggle('intro-open');
    });

    const chips = [...chipsEl.querySelectorAll('.wt-chip')];
    const secs  = [...mainEl.querySelectorAll('.wt-sec')];
    const search = $('[data-wt-search]');
    const empty  = $('[data-wt-empty]');
    const termEl = $('[data-wt-term]');

    /* ---------- 篩選（系統膠囊 + 搜尋，交集） ---------- */
    let activeCat = '';
    function apply() {
      const q = (search.value || '').trim().toLowerCase();
      let anyGlobal = false;
      secs.forEach(sec => {
        const catOk = !activeCat || sec.dataset.cat === activeCat;
        let anyRow = false;
        sec.querySelectorAll('.wt-row').forEach(r => {
          const hit = !q
            || (r.dataset.name || '').toLowerCase().includes(q)
            || r.textContent.toLowerCase().includes(q);
          r.style.display = hit ? '' : 'none';
          if (hit) anyRow = true;
        });
        const intro = sec.querySelector('.wt-intro');
        const introHit = !q || (intro && intro.textContent.toLowerCase().includes(q));
        const show = catOk && (anyRow || introHit);
        sec.style.display = show ? '' : 'none';
        if (show) anyGlobal = true;
      });
      empty.style.display = anyGlobal ? 'none' : 'block';
      if (termEl) termEl.textContent = (search.value || '').trim();
    }
    chips.forEach(ch => ch.addEventListener('click', () => {
      activeCat = ch.dataset.cat || '';
      chips.forEach(x => x.classList.toggle('active', x === ch));
      apply();
    }));
    search.addEventListener('input', apply);
    apply();

    /* ---------- drawer ---------- */
    const scrim   = $('[data-wt-scrim]');
    const drawer  = $('[data-wt-drawer]');
    const dName   = $('[data-d-name]');
    const dEn     = $('[data-d-en]');
    const dStatus = $('[data-d-status]');
    const dDesc   = $('[data-d-desc]');
    const dCond   = $('[data-d-cond]');
    const dMeta   = $('[data-d-meta]');
    const dItems  = $('[data-d-items]');
    const dItemsH = $('[data-d-items-h]');
    let lastFocus = null;

    function setDesc(d) { dDesc.innerHTML = richHTML(d); }
    function setCond(text) {
      const t = (text || '').trim();
      if (t) {
        dCond.hidden = false;
        dCond.innerHTML = `<div class="wt-cond-h">${esc(UI.cond_h)}</div>`
          + `<div class="wt-cond-prose">${richHTML(t)}</div>`;
      } else { dCond.hidden = true; dCond.innerHTML = ''; }
    }

    function openItem(cat, i) {
      const c = CATS.find(x => x.id === cat); if (!c) return;
      const it = M[(c.core || [])[i]]; if (!it) return;
      dName.textContent = nm(it);
      dEn.textContent = IS_EN ? (it.zh || '') : (it.en || '');
      dStatus.className = 'wt-drawer-status';
      dStatus.innerHTML = `<span class="rk">${SVG_CHECK}</span>${esc(c.addon ? UI.st_addon : UI.st_core)}`;
      setDesc((IS_EN && it.desc_en) ? it.desc_en : (it.desc || UI.core_fallback(nm(c))));
      setCond((IS_EN && it.cond_en) ? it.cond_en : it.cond);
      if (dItemsH) { dItemsH.hidden = true; }
      if (dItems) { dItems.innerHTML = ''; }
      dMeta.innerHTML = [c.addon ? UI.addon_test : UI.core_test, nm(c)].map(m => `<span>${esc(m)}</span>`).join('');

      lastFocus = document.activeElement;
      scrim.classList.add('open');
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const closeBtn = $('[data-wt-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeDrawer() {
      scrim.classList.remove('open');
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    mainEl.addEventListener('click', e => {
      const row = e.target.closest('.wt-row');
      if (row) openItem(row.dataset.cat, +row.dataset.i);
    });
    $('[data-wt-close]').addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);
    addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });
  }

  const boot = () => document.querySelectorAll('.bdwt').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', e => {
    const r = e.target.querySelector('.bdwt');
    if (r) init(r);
  });
})();
